import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import LocalityAutoComplete from '../LocalityAutoComplete/LocalityAutoComplete';
import InputText from '../inputs/InputText/InputText';
import InputDate from '../inputs/InputDate/InputDate';
import { GetterTypes } from '@/store-vuex/types';
import ParticipantService from '@/services/participant.service';

@Component({
  components: {
    LocalityAutoComplete,
    InputText,
    InputDate,
  },
})
export default class ParticipantAdministrative extends Vue {
  /**
   * Get the ParticipantDTO instance
   */
  public get participant(): ParticipantDTO {
    return this.$store.getters[GetterTypes.participant];
  }
}
